<template>
  <div class="container">
    <div :class="getClassText()" class="mb-3">Actuele status timesheet: {{getStatusOfTimeSheet()}}</div>
    <div v-if="contractsFetched && selectedContract">
      <b-tabs content-class="mt-3">
        <b-tab
            v-for="contract in activeContracts" :key="contract.id"
            :title="contract.customerName" @click="switchActiveContractTo(contract)"/>
      </b-tabs>
     <ContractDashboard/>
    </div>
    <div v-if="contractsFetched && !selectedContract" class="mt-5">
      <p>
        Er ontbreekt data voor deze gebruiker. Gelieve Ine te contacteren.
      </p>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ContractDashboard from "@/components/ContractSpecificDashboard/ContractSpecificDashboard";

export default {
  name: "Dashboard",
  components: {
    ContractDashboard
  },
  data: () => ({
    contractsFetched: false,
  }),
  computed: {
    ...mapGetters({
      activeContracts: "timesheet/activeContracts",
      selectedContract: "timesheet/selectedContract",
      isLocked: "timesheet/isLocked",
      isCompleted: "timesheet/completed"
    })
  },
  created() {
    this.getAllActiveContractsAndPickSelected()
        .then(() => this.contractsFetched = true);
  },
  methods: {
    ...mapActions("timesheet", [
      'getAllActiveContractsAndPickSelected',
      'fetchPlannedData',
      'fetchAbsenceData',
      'lockPlanning'
    ]),
    ...mapMutations({
      setSelectedContract: "timesheet/setSelectedContract",
    }),
    switchActiveContractTo(contract) {
      this.setSelectedContract(contract);
      this.fetchAbsenceData();
      this.fetchPlannedData();
    },
    getStatusOfTimeSheet() {
      if (!this.isLocked) {
        return "niet gepland";
      }
      else if (this.isLocked && !this.isCompleted) {
        return "bezig";
      }
      else if (this.isCompleted) {
        return "ingediend";
      }
    },
    getClassText() {
      if (!this.isLocked) {
        return "badge badge-secondary";
      }
      else if (this.isLocked && !this.isCompleted) {
        return "badge badge-primary";
      }
      else if (this.isCompleted) {
        return "badge badge-success";
      }
    }
  }
};
</script>
